export const defaultValuesForm = (currentRol: Partial<any> | undefined) => ({
  rol: currentRol?.rol || '',
});
